import { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import { setDocumentTitle } from "@/lib/documentTitle";
import { S3EventsEdit } from "./edit";
import { S3EventsNew } from "./new";
import { S3EventsTable } from "./table";

export default function S3Events() {
  useEffect(() => {
    setDocumentTitle("Quantilia | Events");
  }, []);

  return (
    <Routes>
      <Route path=":id" element={<S3EventsEdit />} />
      <Route index element={<S3EventsTable />} />
      <Route path="/new" element={<S3EventsNew />} />
    </Routes>
  );
}
